define('modules/form_editor/models/input_hidden',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element");
  module.exports = BaseFormElement.extend({
    name: "input:hidden",
    isSocialBindable: true,
    defaultValues: {
      value: "",
      variable: "",
      labelVisible: false,
      socialBinding: "",
      labelText: $.i18n.t("formEditor.hiddenField"),
    }
  });
});

